import { uuid } from '@10000/common'
import { useRef } from 'react'
import { environment, useRequest, useView } from '@10000/react'
import { Box, H3 } from '../widgets'
import { Boolean, Checkbox } from '../forms'
import { InputScreen, useShell } from '../layout'
import { assetUrl } from '../../utilities.js'

export const SquizOptions = ({ active, teamId }) => {
  const request = useRequest('tenant')
  const { teams, user: { preferences } } = useView('tenant')

  const settingsRef = useRef()
  const saveSettingsRef = useRef()
  const startSquizRef = useRef()

  const { guides, tutorial, presenterParticipates, consensus } = preferences || { guides: true, tutorial: true, presenterParticipates: true, consensus: true }

  useShell({ active, mode: 'navigate' })

  const createGame = async ({ saveOptions, ...options }) =>
    request('squizCreated', {
      id: uuid(),
      teamId: teamId || teams[0].id,
      options,
      saveOptions
    })

  return (
    <InputScreen
      centered
      onSubmit={createGame}
      footerButton="Next"
      formValues={{ guides, tutorial, presenterParticipates, consensus, questionCount: 12 }}
      ref={startSquizRef}
    >
      <img src={assetUrl('hand.png')} alt="hand" />

      <H3 align="center">Set up your Squiz</H3>

      <Box column fullWidth gap={16} ref={settingsRef}>
        <Boolean
          name="guides"
          title="Show help guides"
          toolTip="Helps host run a squiz"
        />
        <Boolean
          name="tutorial"
          title="Show tutorial videos"
          toolTip="Show players how to play"
        />
        <Boolean
          name="presenterParticipates"
          title="Host participates"
          toolTip="Allows host to play as well"
        />
        <Boolean
          name="consensus"
          title="Consensus mode"
          toolTip="As a team, debate and agree on a single answer"
        />
        {environment.development &&
          <Boolean name="completedTest" title="Completed test" />
        }
        <Box ref={saveSettingsRef}>
          <Checkbox name="saveOptions" title="Save settings" />
        </Box>
      </Box>
    </InputScreen>
  )
}